var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLearnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1268 15.4986C10.0847 15.4995 10.0424 15.5 10 15.5C6.96243 15.5 4.5 13.0376 4.5 10C4.5 6.96243 6.96243 4.5 10 4.5C13.0376 4.5 15.5 6.96243 15.5 10C15.5 10.1606 15.4931 10.3195 15.4796 10.4766L16.9192 11.0669C16.9724 10.719 17 10.3627 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17C10.2252 17 10.4479 16.9894 10.6676 16.9686L10.1268 15.4986Z",
    fill: "#1A1B1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3697 9.20134C12.0365 8.21228 11.1014 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.0004 8.08759 11.8635 8.93648 12.2632L9.56695 13.9768C7.56149 13.7609 6 12.0628 6 10C6 7.79086 7.79086 6 10 6C12.1653 6 13.9288 7.72049 13.9979 9.86899L12.3697 9.20134Z",
    fill: "#1A1B1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10L19 13.6906L15.305 15.6136L13.5871 19.75L10 10Z",
    fill: "#1A1B1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearnIcon);
export default __webpack_public_path__ + "static/media/learn-icon.90d4200660e67549e8a07fdab44fea7a.svg";
export { ForwardRef as ReactComponent };